import { Action, createReducer, on } from '@ngrx/store';

import { PackageStep } from '@packages/packages-search-bar/constants/package-step';
import { resetPackageStepAction, setPackageStepAction } from '@shared/base-search-bar/store/actions/search-bar.actions';

export const initialState = null;

const reducer = createReducer(
  initialState,
  on(setPackageStepAction, (state, { code }) => code),
  on(resetPackageStepAction, () => initialState)
);

export function packageStepReducer(state: string, action: Action): PackageStep {
  return reducer(state, action);
}
